module.exports = __webpack_public_path__ + "fonts/fira-sans-v8-latin-700.eb271b5.woff2";